export const setItem = (state, payload) => state.item = payload
